import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import AppointmentPage from '../../page/AppointmentPage';
import store from '../../configureStore';
import * as settingActions from '../../actions/settings';
import ComponentWidgetContainer from '../ComponentWidgetContainer';

export default class AppointmentWidgetContainer extends ComponentWidgetContainer {
  componentDidMount() {
    super.componentDidMount();

    if (!this.variantId()) {
      console.log('External ID not found');
    }
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <AppointmentPage />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = (value) => store.dispatch(settingActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingActions.setTranslation({ key, value }));
};
window.changeSetting = (key, value) => store.dispatch(settingActions.setSetting({ key, value }));

AppointmentWidgetContainer.propTypes = {
  defaultTranslation: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
};
